import { render, staticRenderFns } from "./Digital.vue?vue&type=template&id=0fb21685&scoped=true"
import script from "./Digital.vue?vue&type=script&lang=js"
export * from "./Digital.vue?vue&type=script&lang=js"
import style0 from "./Digital.vue?vue&type=style&index=0&id=0fb21685&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb21685",
  null
  
)

export default component.exports